"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _formik = require("formik");
var _SearchForm = _interopRequireDefault(require("../../Baskets/components/SearchForm"));
var _constants = require("../../Baskets/components/SearchForm/constants");
var _Results = _interopRequireDefault(require("../../Baskets/components/Results"));
var _Pagination = _interopRequireDefault(require("../../ui/Pagination"));
var _actions = require("./store/actions");
var _selectors = require("./store/selectors");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var BasketsPage = function BasketsPage() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var isReady = (0, _reactRedux.useSelector)(_selectors.getIsReady);
  var total = (0, _reactRedux.useSelector)(_selectors.getBasketTotal);
  var perPage = (0, _reactRedux.useSelector)(_selectors.getBasketPerPage);
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.bootstrapBasketsPage)());
    return function () {
      dispatch((0, _actions.resetBasketsPage)());
    };
  }, [dispatch]);
  return isReady && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement(_SearchForm.default, null, /*#__PURE__*/_react.default.createElement(_Results.default, null), !!total && /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _constants.FORM_FIELDS.PAGE,
    render: function render(_ref) {
      var field = _ref.field,
        form = _ref.form;
      return /*#__PURE__*/_react.default.createElement(_Pagination.default, {
        className: _styles.default.pagination,
        page: field.value,
        perPage: perPage,
        totalCount: total,
        onChange: function onChange(page) {
          return Promise.resolve().then(function () {
            return form.setFieldValue(_constants.FORM_FIELDS.PAGE, page);
          }).then(form.submitForm);
        }
      });
    }
  })));
};
var _default = exports.default = (0, _react.memo)(BasketsPage);